<div class="vo-central-content">
  <div class="heading-image"></div>
  <div class="login-extended-functionality-container mt-30 mx-auto text-center">
    <div *ngIf="hasExceededMaximumOtpSendLimit" class="vo-info-box--danger-top mb-15 w-100">
      {{ referenceDataLabels.VerificationCodeHasExceededMaximumOtpSendLimit | localizeLabel }}
    </div>
    <a
      *ngIf="hasExceededMaximumOtpSendLimit"
      class="vo-link text-center mb-30 fs-14"
      (click)="goToLogin()"
      [innerHTML]="referenceDataLabels.BackToLogin|localizeLabel"
    ></a>

    <ng-container *ngIf="!hasExceededMaximumOtpSendLimit">
      <div class="p-30">
        <div class="vo-heading-bold-24 mb-30" [innerHTML]="referenceDataLabels.ResetYourPassword | localizeLabel"></div>

        <div *ngIf="isEmailSent" class="align-items-center d-flex justify-content-center vo-body-regular-14 my-30">
          <div class="email-sent-icon mr-15 ml-n30 flex-none"></div>
          <span [innerHTML]="referenceDataLabels.ResetForgottenPasswordSuccess | localizeLabel : emailAddress"></span>
        </div>

        <div
          *ngIf="!isEmailSent"
          class="vo-body-regular-14 my-30"
          [innerHTML]="referenceDataLabels.UserPasswordReset | localizeLabel | toTrustedHtml"
        ></div>
      </div>

      <div
        *ngIf="shouldDisplayErrorMessage && !isEmailSent"
        class="vo-info-box--danger-top vo-body-regular-14 my-30"
        [innerHTML]="referenceDataConstants.ERROR_MESSAGE_USER_ACCOUNT | localizeErrorMessage: referenceDataLabels.ResetPasswordError | toTrustedHtml"
      ></div>

      <form
        *ngIf="!isEmailSent && !isResendPossible"
        #forgottenPasswordForm="ngForm"
        (ngSubmit)="continue(forgottenPasswordForm)"
      >
        <boi-text-input
          class="field-input-full-width field-text-center"
          [ngClass]="{'error-state': shouldDisplayErrorMessage && !isEmailSent}"
          cssClasses="label-top"
          [required]="true"
          [type]="'email'"
          required
          name="email"
          [(ngModel)]="emailAddress"
          [labelName]="referenceDataLabels.ForgottenEmailAddress"
          #emailAddressInput="ngModel"
        >
        </boi-text-input>

        <button
          class="vo-primary-button-1 my-30 w-100"
          type="submit"
          [disabled]="!emailAddress || emailAddressInput.hasError('email')"
          [innerHTML]="referenceDataLabels.ResetPassword | localizeLabel"
        ></button>

        <a
          class="vo-link text-center mb-30 fs-14"
          (click)="goToLogin()"
          [innerHTML]="referenceDataLabels.BackToLogin|localizeLabel"
        ></a>
      </form>
    </ng-container>
  </div>
</div>
